import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  CircularProgress,
  Alert,
} from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { userApi } from '../services/api';

const TokenPurchaseSuccess: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [tokenBalance, setTokenBalance] = useState<number | null>(null);

  useEffect(() => {
    const fetchTokenBalance = async () => {
      try {
        const response = await userApi.getTokenBalance();
        setTokenBalance(response.data.tokens);
      } catch (err) {
        setError('Failed to fetch token balance');
        console.error('Error fetching token balance:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTokenBalance();
  }, []);

  const handleContinue = () => {
    const returnTo = location.state?.returnTo || '/';
    navigate(returnTo);
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          mt: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <CheckCircleIcon color="success" sx={{ fontSize: 80, mb: 2 }} />
        
        <Typography variant="h4" gutterBottom>
          Purchase Successful!
        </Typography>

        <Typography variant="body1" color="text.secondary" paragraph>
          Thank you for your purchase. Your tokens have been added to your account.
        </Typography>

        {tokenBalance !== null && (
          <Typography variant="h6" color="primary" gutterBottom>
            Current Balance: {tokenBalance} tokens
          </Typography>
        )}

        {error && (
          <Alert severity="error" sx={{ mt: 2, width: '100%' }}>
            {error}
          </Alert>
        )}

        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleContinue}
          sx={{ mt: 4 }}
        >
          Continue
        </Button>
      </Box>
    </Container>
  );
};

export default TokenPurchaseSuccess; 